import {
    LISTAR_NOTAS_INTERCONSULTA,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_NOTAS_INTERCONSULTA:
            return{
                ...state, 
                notasInterconsulta: action.payload
            }
        default:
            return state
    }
        
}